import axios from 'axios'
import { config } from '../../Constants'

export const tripApi = {
  getTrips,
  getTripsMeAsDriver,
  getTripsMeAsPass,
  getTrip,
  createTrip,
  createUsertrip,
  getCurrentUsertrips,
  getOldUsertrips,
  getCurrentDrivertrips,
  getOldDrivertrips,
  approveUsertrip,
  rejectUsertrip,
  cancelTrip,
  completeTrip,
  getTripsPage,
  deleteTrip,
  getUserTripsPage,
  deleteUserTrip
}

function getTrips(user) {
  const url = '/api/trips';
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}


function getTripsPage(user, offset) {
  const url = '/api/trips/paged?offset='+offset
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function getUserTripsPage(user, offset) {
  const url = '/api/trips/upaged?offset='+offset
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function getTripsMeAsDriver(user) {
  const url = '/api/trips/measdriver';
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function getTripsMeAsPass(user) {
  const url = '/api/trips/measpass';
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function getTrip(user, id) {
  const url = '/api/trips/' + id;
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function createUsertrip(user, id) {
  const url = '/api/trips/usertrip/' + id;
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function getCurrentUsertrips(user) {
  const url = '/api/trips/currentusertrips';
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function getOldUsertrips(user) {
  const url = '/api/trips/oldusertrips';
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function getCurrentDrivertrips(user) {
  const url = '/api/trips/currentdrivertrips';
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function getOldDrivertrips(user) {
  const url = '/api/trips/olddrivertrips';
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function approveUsertrip(user, id) {
  const url = '/api/trips/approveusertrip/' + id;
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function rejectUsertrip(user, id) {
  const url = '/api/trips/rejectusertrip/' + id;
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function deleteTrip(user, id) {
  return instance.delete(`/api/trips/${id}`, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function deleteUserTrip(user, id) {
  return instance.delete(`/api/trips/usertrip/${id}`, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function createTrip(user, trip) {
  return instance.post('/api/trips', trip, {
    headers: {
      'Content-type': 'application/json',
      'Authorization': basicAuth(user)
    }
  })
}

function cancelTrip(user, id) {
  const url = '/api/trips/canceltrip/' + id;
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function completeTrip(user, id) {
  const url = '/api/trips/completetrip/' + id;
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}


// -- Axios

const instance = axios.create({
  baseURL: config.url.API_BASE_URL
})

// -- Helper functions

function basicAuth(user) {
  return `Basic ${user.authdata}`
}
